import { render, staticRenderFns } from "./ArticleReleaseArrive.vue?vue&type=template&id=ff0a00bc&scoped=true"
import script from "./ArticleReleaseArrive.vue?vue&type=script&lang=js"
export * from "./ArticleReleaseArrive.vue?vue&type=script&lang=js"
import style0 from "./ArticleReleaseArrive.vue?vue&type=style&index=0&id=ff0a00bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff0a00bc",
  null
  
)

export default component.exports